import React from 'react';

import { ChargePointDTO } from 'entities/charge-point';
import { ChargePointsMap } from 'entities/charge-points-map';
import { MapProps } from 'entities/charge-points-map/ui/map';

import {
  Address,
  AddressInfo,
  AddressTitle,
  LocationContainer,
  MapContainer,
  StyledCard,
} from './styles';

const DEFAULT_MAP_ZOOM = 13;

type Props = {
  address: string;
  chargePoint: ChargePointDTO;
};

export function LocationCard({ address, chargePoint }: Props) {
  const { latitude, longitude } = chargePoint;

  const mapCenter = [latitude, longitude];

  const mapProps: MapProps = {
    defaultState: {
      center: mapCenter,
      zoom: DEFAULT_MAP_ZOOM,
      controls: ['zoomControl', 'geolocationControl'],
    },
    options: {
      suppressMapOpenBlock: true,
      yandexMapDisablePoiInteractivity: true,
      autoFitToViewport: 'always',
    },
    // modules: [
    //   'templateLayoutFactory',
    //   'control.ZoomControl',
    //   'control.GeolocationControl',
    // ],
  };

  return (
    <StyledCard>
      <LocationContainer>
        <AddressInfo>
          <AddressTitle>Местоположение ЭЗС</AddressTitle>
          <Address>{`Адрес: ${address}`}</Address>
        </AddressInfo>
        <MapContainer>
          <ChargePointsMap chargePoints={[chargePoint]} mapProps={mapProps} />
        </MapContainer>
      </LocationContainer>
    </StyledCard>
  );
}

export default React.memo(LocationCard);
